import type { SharedTypes } from '@semios/app-platform-banyan-route-definitions'
import { ExternalVendorIcons } from 'components/ExternalVendorIcons/ExternalVendorIcons'
import { getExternalVendorIconItems } from 'utils/getExternalVendorIconItems'

export const NameWithExternalVendorIcons = ({
  name,
  externalVendorNames = [],
  iconSize = 16,
}: {
  name: string
  externalVendorNames?: SharedTypes.IrrigationScheduler.EIrrigationVendorName[]
  iconSize?: number
}) => {
  if (getExternalVendorIconItems(externalVendorNames).length === 0) return name

  return (
    <>
      {name}
      <span css={{ display: 'inline-flex', verticalAlign: 'middle', marginLeft: 8 }}>
        <ExternalVendorIcons externalVendorNames={externalVendorNames} size={iconSize} />
      </span>
    </>
  )
}
